import DefaultEcoRestorationProgress from "src/components/feature/DemandNoteViewProgress";

const EcoRestorationProgress = () => {
  return <></>;
};

export default EcoRestorationProgress;
